import * as React from 'react'
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select
} from '@mui/material'
import { useStore } from 'effector-react'
import {
  $isAccountPaidFilter,
  $isContractReturnedFilter,
  buildSignedContractsFilters,
  setIsAccountPaidFilter,
  setIsContractReturnedFilter
} from './store'

export type FilterValue = 'all' | 'yes' | 'no'
export type { SignedContractsFilters } from './store'
export { buildSignedContractsFilters }

export const useSignedContractsFilters = (): {
  isAccountPaid: FilterValue
  isContractReturned: FilterValue
} => {
  const isAccountPaid = useStore($isAccountPaidFilter)
  const isContractReturned = useStore($isContractReturnedFilter)

  return {
    isAccountPaid,
    isContractReturned
  }
}

interface SignedContractsReportFilterProps {
  onExport: () => void
}

export default function SignedContractsReportFilter({
  onExport
}: SignedContractsReportFilterProps) {
  const isAccountPaid = useStore($isAccountPaidFilter)
  const isContractReturned = useStore($isContractReturnedFilter)

  return (
    <Box display="flex" gap={2} flexWrap="wrap" alignItems="center">
      <FormControl sx={{ minWidth: 240 }}>
        <InputLabel id="is-account-paid-label">Счёт оплачен</InputLabel>
        <Select
          labelId="is-account-paid-label"
          value={isAccountPaid}
          label="Счёт оплачен"
          onChange={(e) =>
            setIsAccountPaidFilter(e.target.value as FilterValue)
          }
        >
          <MenuItem value="all">Все</MenuItem>
          <MenuItem value="yes">Да</MenuItem>
          <MenuItem value="no">Нет</MenuItem>
        </Select>
      </FormControl>

      <FormControl sx={{ minWidth: 280 }}>
        <InputLabel id="is-contract-returned-label">
          Договор возвращён контрагентом
        </InputLabel>
        <Select
          labelId="is-contract-returned-label"
          value={isContractReturned}
          label="Договор возвращён контрагентом"
          onChange={(e) =>
            setIsContractReturnedFilter(e.target.value as FilterValue)
          }
        >
          <MenuItem value="all">Все</MenuItem>
          <MenuItem value="yes">Да</MenuItem>
          <MenuItem value="no">Нет</MenuItem>
        </Select>
      </FormControl>

      <Button variant="outlined" onClick={onExport}>
        Экспорт в Excel
      </Button>
    </Box>
  )
}
